/**
 * Cardio Video Mapping
 * Maps modality_id → video URL for cardio exercises that have video assets.
 * Videos are stored in the "Original Cardio Blocks" Supabase bucket.
 * The existing cardioImages.js remains the fallback for all exercises.
 */

const SUPABASE_STORAGE = 'https://xiccdxfifzrdfynwslju.supabase.co/storage/v1/object/public/Original%20Cardio%20Blocks';

const CARDIO_VIDEOS = {
  treadmill_run: `${SUPABASE_STORAGE}/treadmill%20Run.mp4`,
  treadmill_walk: `${SUPABASE_STORAGE}/Treadmill%20walk.mp4`,
  outdoor_run: `${SUPABASE_STORAGE}/outdoor%20run.mp4`,
  outdoor_walk: `${SUPABASE_STORAGE}/outdoor%20walk.mp4`,
  mountain_climbers: `${SUPABASE_STORAGE}/Mountain%20climbers.mp4`,
  row_erg: `${SUPABASE_STORAGE}/Rowing%20Machine.mp4`,
  shadow_boxing: `${SUPABASE_STORAGE}/shadow%20boxing.mp4`,
  squat_thrusts: `${SUPABASE_STORAGE}/Squat%20thrusts.mp4`,
  squat_to_reach: `${SUPABASE_STORAGE}/squat%20to%20reach.mp4`,
  stair_climber: `${SUPABASE_STORAGE}/stair%20climber.mp4`,
  stationary_bike: `${SUPABASE_STORAGE}/stationary%20bike%202.mp4`,
  step_ups: `${SUPABASE_STORAGE}/step%20ups.mp4`,
  high_knee_runs: `${SUPABASE_STORAGE}/high%20knee%20runs.mp4`,
  jump_rope: `${SUPABASE_STORAGE}/jump%20rope.mp4`,
  jumping_jacks: `${SUPABASE_STORAGE}/jumping%20jacks.mp4`,
  elliptical: `${SUPABASE_STORAGE}/Elliptical%20Trainer.mp4`,
  burpees: `${SUPABASE_STORAGE}/Burpees.mp4`,
  brisk_march: `${SUPABASE_STORAGE}/brisk%20march.mp4`,
};

/**
 * Look up a video URL by modality_id, falling back to the movement name
 * (warm-up cardio only carries a name, never an id).
 */
export function getCardioVideo(modalityId, name) {
  if (modalityId && CARDIO_VIDEOS[modalityId]) return CARDIO_VIDEOS[modalityId];
  if (!name) return null;
  const slug = name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  if (CARDIO_VIDEOS[slug]) return CARDIO_VIDEOS[slug];
  const lower = name.toLowerCase();
  for (const [key, url] of Object.entries(CARDIO_VIDEOS)) {
    if (lower.includes(key.replace(/_/g, ' '))) return url;
  }
  return null;
}
